import React from 'react';
import {
    AnimatedTabs,
    Card,
    Details,
    DetailsStringValue,
} from 'components';
import {
    IExamDetails,
} from 'components/models';
import { Tab } from 'react-bootstrap';
import { IApiError } from '_helpers/ApiConnector/types';
import { formatPhoneNumber } from '_helpers';

const ExamDetailsConfirmationStatus = ({
                 examDetails,
                 ...props
             }: IProps) => {
    
    const [activeTab, setActiveTab] = React.useState(TabKey.Info);
    
    return (
        <>
            <AnimatedTabs
                id="ExamDetailsConfirmationStatus"
                activeKey={activeTab}
                onSelect={(key: string) => setActiveTab(key as TabKey)}
            >
                <Tab eventKey={TabKey.Info} title="Информация" className="tab p-0">
                    <Card
                        withoutBorder
                        title="Информация об аккредитации"
                        category="Общая информация о планируемом аккредитационном мероприятии"
                        contentClassName="pt-0"
                    >
                        <Details withDarkRowLabel
                            infoRows={[
                                new DetailsStringValue('СПЕЦИАЛЬНОСТЬ', examDetails.qualificationTitle),
                                new DetailsStringValue('СЕКРЕТАРЬ АПК', examDetails.secretaryFullName),
                                new DetailsStringValue('ТЕЛЕФОН', formatPhoneNumber(examDetails.secretaryPhone) || ''),
                            ]} />
                        
                        {examDetails.examStages.map((s,i) => (
                            <Details
                                withDarkRowLabel
                                title={`Этап ${i + 1}`}
                                infoRows={[
                                    new DetailsStringValue('ДАТА НАЧАЛА', s.firstDayDateTime.local().format('DD.MM.YYYY')),
                                    new DetailsStringValue('ВРЕМЯ НАЧАЛА',`${s.firstDayDateTime.local().format('HH:mm')} (${s.firstDayDateTime.local().tz('Europe/Moscow').format('HH:mm')} МСК)` ),
                                    new DetailsStringValue('ВМЕСТИМОСТЬ (ЧЕЛ/ДЕНЬ)', s.audienceCapacity.toString()),
                                ]} />
                        ))}
                        
                    </Card>
                    {props.renderAppendForInfo && props.renderAppendForInfo(examDetails)}
                </Tab>

                <Tab eventKey={TabKey.TechnicalSupport} title="Техническое обеспечение" className="tab p-0">
                    <Card
                        withoutBorder
                        title="Информация о техническое обеспечении"
                        category="Здесь будет информация о техническое обеспечении"
                        contentClassName="pt-0"
                    >
                    </Card>
                </Tab>

               
            </AnimatedTabs>
        </>
    );
};

export default ExamDetailsConfirmationStatus;

export interface IProps {
    examDetails: IExamDetails;
    error: IApiError | null;
    renderAppendForInfo?: (ed: IExamDetails) => JSX.Element | undefined | null | boolean;
}


enum TabKey {
    Info = 'info',
    TechnicalSupport = 'technicalSupport',
}

type TabType = 'info' | 'technicalSupport'